import React, { useRef, useState, useEffect } from 'react';
import { 
  FacebookShareButton, 
  LinkedinShareButton, 
  EmailShareButton, 
  FacebookMessengerShareButton, 
  WhatsappShareButton, 
  } from "react-share";
import {
  FacebookIcon,
  LinkedinIcon,
  EmailIcon,
  FacebookMessengerIcon,
  WhatsappIcon
} from "react-share";


import './share.css';

const Share = ({ postId }) => {

  const [drop, setDrop] = useState(null);
  const dropRef = useRef(null);

  const fullPostUrl = `https://gandan-frontend.vercel.app/posts/${postId}`

  const handleDrop = (menu) => {
    setDrop(drop === menu ? null : menu)
  }

  //Close the dropdown when clicking outside
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (dropRef.current && !dropRef.current.contains(event.target)){
          setDrop(null); // close the dropdown
        }
      };
      
      // Add event listener to the document
      document.addEventListener('mousedown', handleClickOutside);
  
      // Cleanup the event listener when component unmounts;
      return () => {
        document.removeEventListener('mousedown', handleClickOutside)
      };
    }, []) // Empty dependency array to run only once when components mounts
  

  return (
      <ul className='share-ul-container'>
        <li onClick={() => handleDrop('share')} className='share-li-container'>
          <div className='share-button' >
            <button>Share</button>
          </div>
         
     
          
          <div ref={dropRef} className={`share-drop ${drop === "share" ? "show" : "hide"}`}>   
            <div >
              <FacebookShareButton
                url={fullPostUrl}
                quote=''
                hashtag={fullPostUrl}
              >
                <FacebookIcon className='share-icons' />
              </FacebookShareButton>
            </div>
  
            <div>
              <LinkedinShareButton
                url={fullPostUrl}
                quote=''
                hashtag={fullPostUrl}
              >
                <LinkedinIcon className='share-icons'/>
              </LinkedinShareButton>
            </div>
      
            <div>
              <EmailShareButton
                url={fullPostUrl}
                quote=''
                hashtag={fullPostUrl}
              >
                <EmailIcon className='share-icons'/>
              </EmailShareButton>
            </div>
     
            <div>
              <FacebookMessengerShareButton
                url={fullPostUrl}
                quote=''
                hashtag={fullPostUrl}
              >
                <FacebookMessengerIcon className='share-icons'/>
              </FacebookMessengerShareButton>
            </div>
     
            <div>
              <WhatsappShareButton
                url={fullPostUrl}
                quote=''
                hashtag={fullPostUrl}
              >
                <WhatsappIcon className='share-icons'/>
              </WhatsappShareButton>
            </div>
          </div>
        </li>
      </ul>     
  )
}

export default Share;

